import { useSelector } from 'react-redux';

import { CAROUSEL_EPISODES_LIMIT, Routes } from '@/constants';
import { Link } from '@/containers';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectBookmarkedEpisodeIds,
  selectUserCompliance,
  useFetchEpisodesQuery,
} from '@/store';

import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

export const BookmarkedEpisodesCarousel = () => {
  const compliance = useSelector(selectUserCompliance);

  const bookmarkedEpisodeIds = useSelector(selectBookmarkedEpisodeIds).slice(
    0,
    CAROUSEL_EPISODES_LIMIT,
  );

  const { data: episodes = [], isSuccess } = useFetchEpisodesQuery(
    {
      episodeIds: bookmarkedEpisodeIds,
      compliance,
    },
    {
      skip: !bookmarkedEpisodeIds?.length,
    },
  );

  const ViewAllLink = () => (
    <Link to={`${Routes.MY_LUMIQ}?tab=bookmarked`}>View All</Link>
  );

  const isEmpty =
    !bookmarkedEpisodeIds.length || (isSuccess && !episodes.length);

  return (
    !isEmpty && (
      <EpisodeCardCarousel
        title="Bookmarked Episodes"
        uKey="Bookmarked Episodes"
        episodes={episodes}
        ViewAllLink={ViewAllLink}
        referrer={{
          page: EVENT_CONSTANTS.PAGE.DISCOVER,
        }}
      />
    )
  );
};
